$(function() {
  NotificationSystem.init();
});

var BaseUrl = $('body').attr('baseurl');
var NotificationSystem = {
  init: function() {
    var self = this;
    this.$counters = $('.notification-counter');
    this.$container = $('#new_notifications');
    this.$error_import = $('#error_import');
    this.makeNotification = _.template(
        '<button type="button" data-id="<%= id %>" class="btn btn-xs btn-danger btn-flat dismiss-notify pull-right" title="Dispensar"> ' +
        ' <i class="fa fa-times"></i> ' +
        '</button> ' +
      '<a href="<%= data.link %>" data-id="<%= id %>" class="js-notification" >' +
      '<i class="fa fa-<%= data.task ? "exclamation-triangle" : "comment" %> text-<%= data.task ? "danger" :"warning" %>"></i>' +
      '<%= data.message %>' +
      '</a>'
    );

    $('body').on('click', '.js-notification', function(event) {
      var notification = event.currentTarget;
      var ajax = self.markAsRead(notification.dataset.id);

      startLoading();
      ajax.always(stopLoading);

      if(notification.href && notification.href !== '#') {
        event.preventDefault();
        ajax.done(function() {
          location.href = notification.href;
        });
      }
    });
    $body.on('click', '.dismiss-notify', function(event) {
      startLoading();
      var notification = event.currentTarget;
      var ajax = self.markAsRead(notification.dataset.id);
      var counters = document.querySelectorAll('.notification-counter');

      $('[data-id="'+notification.dataset.id+'"]').remove();

      counters.forEach(function(item) {
        item.innerText = (item.innerText - 1);
      });

      if (counters[0].innerText == 0) {
        document.querySelector('div.clear-all').style.display = 'none';
      }

      setTimeout(function () {
        $('#dropdown_notification').click();

        stopLoading();
      }, 1000);
    });
    $body.on('click', '.clear-all', function (event) {

      var userId, request;
      userId = this.getAttribute('data-user-id');
      if (userId) {
        var options = {
          title: 'Limpar todas as notificações?',
          text: 'Ao confirmar não será possível voltar atrás',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
          confirmButtonColor: '#7ED32C'
        };

        swal(options,
          self.markAllAsRead.bind(this)
        );
      }
    });

    if(this.$container.length) {
      this.verifyNotifications();
      setInterval(this.verifyNotifications.bind(this), 90000);
    }
  },
  updateCounters: function(val) {
    var clearAll = document.querySelector('div.clear-all');
    if (val == 0) {
      clearAll.style.display = 'none';
    } else {
      clearAll.style.display = 'block';
    }
    return this.$counters.text(val);
  },
  clearContainer: function() {
    this.$container.html('');
  },
  verifyNotifications: function() {
    var ajax = $.get(BaseUrl + '/notifications');
    ajax.done(this.successCallback.bind(this));
    ajax.fail(function () {
        window.top.location.reload();
    });
  },
  markAsRead: function(id) {
    return $.post(BaseUrl + '/notifications/' + id + '/mark-as-read');
  },
  markAllAsRead: function() {
  startLoading();
    $.post(BaseUrl + '/notifications/' + this.getAttribute('data-user-id') + '/mark-all-as-read')
      .done(function (data) {
        stopLoading();
        swal({
          title: 'Sucesso!',
          text: data.success,
          type: 'success',
          allowOutsideClick: true,
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1000
        }, function() {
          setTimeout(function () {
            location.reload();
          }, 1000);
        });
    }).fail(function (err) {
        stopLoading();
        swal({title:'Ops!', text: err.responseJSON.error,
          type:'error', allowOutsideClick: true, showCancelButton: false,
          showConfirmButton: false});
    });
  },
  successCallback: function(notifications) {
    var self = this;
    this.updateCounters(notifications.length);
    this.clearContainer();

    notifications.filter(function(notification) {
        return self.parse(notification);
    });


    $('.notifications-menu .menu').slimScroll({
      height: '200px'
    });

  },
  parse: function (notification) {
    var link = notification.data.link;
    if ((link.includes('https://') || link.includes('http://')) && !link.includes('.s3.')) {
      var urlObject = new URL(link);
      notification.data.link = BaseUrl + urlObject.pathname + urlObject.search;
    }

    this.$container.append(this.makeNotification(notification));
  }
};

